export const PDP_GALLERY_BADGE_OVERLAY_ATTR = 'data-pdp-gallery-badge-overlay';

export const PDP_GALLERY_BADGE_OVERLAY_SELECTOR = `[${PDP_GALLERY_BADGE_OVERLAY_ATTR}]`;
